import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { SUPPORT_PHONE, SUPPORT_PHONE_TEL } from '../data/site_emails.js'

const FormSidebar = () => (
  <aside className="hire_form_sidebar">
    <StaticImage
      src="../images/callcentre.jpg"
      alt="Customer Support"
      className="hire_form_sidebar_img"
      style={{ display: 'block', width: '100%' }}
      imgStyle={{ objectFit: 'cover', width: '100%', height: '100%' }}
    />
    <div className="hire_form_contact_box">
      <div className="hire_form_phone_icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.4 21 3 13.6 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.25 1.02l-2.2 2.2z" />
        </svg>
      </div>
      <div className="hire_form_contact_text">
        <span>Got a Forklift Question?</span>
        <span>We've got the Answer!</span>
        <a href={`tel:${SUPPORT_PHONE_TEL}`} title={SUPPORT_PHONE} rel="nofollow noopener">{SUPPORT_PHONE}</a>
      </div>
    </div>
  </aside>
)

export default FormSidebar
